export default __webpack_public_path__ + "static/media/icon-start.c8c36a2d.svg";